import { SVG } from "@components/items/common/SVG";
import TranslatedText from "@components/items/display/TranslatedText";
import { useLanguage } from "@modules/localizations/LanguageContext";
import { Avatar } from "@mui/material";
import { Card } from "@ui/card";
import { Share } from "lucide-react";

const InfoCard = ({
  avatar,
  fullName,
  email,
  booksCount,
  continuity,
  listeningDuration,
}: {
  avatar: string;
  fullName: string;
  email: string;
  booksCount: number;
  continuity: number;
  listeningDuration: number;
}) => {
  const { language } = useLanguage();

  return (
    <Card className="w-full border-none bg-[#D9D9D9]/15 p-5 text-black dark:text-white">
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center justify-center gap-5">
          <Avatar className="h-28 w-28 items-center justify-center bg-white text-[20px] font-bold dark:bg-black/40">
            {avatar}
          </Avatar>
          <div className="flex flex-col items-start justify-center">
            <div className="text-[16px] font-bold">{fullName}</div>
            <div>{email}</div>
          </div>
        </div>
        {/* <Share className="cursor-pointer self-start text-[#D9D9D9]" size={30} /> */}
      </div>
      <div className="flex w-full items-center justify-around py-5">
        <Card
          className="flex w-1/4 items-center justify-center gap-8 border-none bg-cover px-6 py-10"
          style={{
            backgroundImage: "url(/assets/images/profile-card-bg.png)",
          }}
        >
          <SVG src="/assets/icons/settings/book-count.svg" />
          <div className="flex flex-col items-center justify-center text-[#E85578]">
            <div className="text-[30px] font-medium">{booksCount}</div>
            <TranslatedText
              text={`settings.titles.${"book count"}`}
              className="text-[18px]"
            />
          </div>
        </Card>
        <Card
          className="flex w-1/4 items-center justify-center gap-8 border-none bg-cover px-6 py-10"
          style={{
            backgroundImage: "url(/assets/images/profile-card-bg.png)",
          }}
        >
          <SVG src="/assets/icons/settings/listening-duration.svg" />
          <div className="flex flex-col items-center justify-center text-[#4393C0]">
            <div className="text-[30px] font-medium">
              {listeningDuration}
              {language === "ar" ? "س" : "h"}
            </div>
            <TranslatedText
              text={`settings.titles.${"listening duration"}`}
              className="text-[18px]"
            />
          </div>
        </Card>
        <Card
          className="flex w-1/4 items-center justify-center gap-8 border-none bg-cover py-10"
          style={{
            backgroundImage: "url(/assets/images/profile-card-bg.png)",
          }}
        >
          <SVG src="/assets/icons/settings/continuity.svg" />
          <div className="flex flex-col items-center justify-center text-[#DDA10A]">
            <div className="text-[30px] font-medium">{continuity}</div>
            <TranslatedText
              text={`settings.titles.${"continuity"}`}
              className="text-[18px]"
            />
          </div>
        </Card>
      </div>
    </Card>
  );
};

export default InfoCard;
